// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ItemNoResults_wrapper__2LbY7","titleWrapper":"ItemNoResults_titleWrapper__1yzfH","description":"ItemNoResults_description__1O5EJ"};